import React, { useEffect, useRef, type ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { useMatches } from 'react-router';

import useAuth from '../AppLayout/hooks/useAuth';

interface AuthenticatorProps {
  children: ReactNode;
}

interface AuthRouteHandle {
  requiresAuth?: boolean;
}

const Authenticator = ({ children }: AuthenticatorProps): React.ReactNode => {
  const intl = useIntl();
  const { initialized, authenticated, interactionInProgress, login } = useAuth();
  const matches = useMatches();
  const loginAttemptedRef = useRef(false);

  const isProtectedRoute = matches.some(
    match => (match.handle as AuthRouteHandle | undefined)?.requiresAuth === true
  );
  const requiresLogin = isProtectedRoute && initialized && !authenticated && !interactionInProgress;

  useEffect(() => {
    if (!requiresLogin) {
      loginAttemptedRef.current = false;
      return;
    }

    if (!loginAttemptedRef.current) {
      loginAttemptedRef.current = true;
      login();
    }
  }, [login, requiresLogin]);

  if (isProtectedRoute) {
    if (!initialized) return <p>{intl.formatMessage({ id: 'initializing' })}</p>;
    if (!authenticated) return null;
  }
  return children;
};

export default Authenticator;
